import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "lodash";
import ReactTable from "react-table";
import { Button, ButtonGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popconfirm } from "antd";

import ReactTableFilterSelect from "helpers/react-table-filter-select";
import filterCaseInsensitive from "helpers/react-table-case-insensitive";
import {
    openCustomModal,
    closeCustomModal
} from "views/lib/components/modals";

import {
    fetchCities,
    fetchProvinceById,
    clearCities,
    deleteCity
} from "actions/locations/actions";

// import CityModal from "components/menu/master-files/locations/city-modal";
import CityModal from "views/pages/locations/city-modal";

class CitiesList extends React.Component {
    constructor(props) {
        super(props);

        this.cityModalOpen = this.cityModalOpen.bind(this);
    }

    componentDidMount() {
        this.props.fetchCities(this.props.match.params.id);
        this.props.fetchProvinceById(this.props.match.params.id);
    }

    componentWillUnmount () {
        this.props.clearCities();
    }

    getProvinceName = () => {
        if (this.props.currentProvince && this.props.currentProvince.fullName) {
            return `of ${this.props.currentProvince.fullName}`;
        }
        return "";
    };

    cityModalOpen = (cityId = false) => {
        const modalObj = {
            modalSettings: {
                size: "lg"
            },
            header: "City Modal",
            children: (
                <CityModal
                    cityId={cityId}
                    onCancel={() => this.props.closeCustomModal(modalObj)}
                />
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    delete = (cityId, name) => {
        this.props.deleteCity(
            cityId,
            name,
            () => this.props.fetchCities(this.props.match.params.id)
        );
    };

    render () {
        const { cities, loading } = this.props;

        const classNameFlexCenter = "d-flex justify-content-center align-items-center";
        const columns = [
            {
                Header: "Name",
                accessor: "name",
                Cell: ({ original }) => (
                    /* <a href="#" onClick={() => this.cityModalOpen(original.id)}> */
                        original.name
                    /* </a> */
                ),
                id: "name",
            },
            {
                Header: "Travel Charge",
                accessor: "travelCharge",
                id: "travelCharge",
                Filter: ({ filter, onChange }) => {
                    const travelChargeArr = [];
                    this.props.cities.forEach((value) => {
                        travelChargeArr.push(value.travelCharge);
                    });
                    return (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: "100%", height: "100%" }}
                            value={filter ? filter.value : ""}
                        >
                            <option value="">Show All</option>
                            {_.uniq(travelChargeArr).map((value, index) => (
                                <option key={index} value={value}>
                                    {value}
                                </option>
                            ))}
                        </select>
                    );
                }
            },
            {
                Header: "Is Travel Region",
                id: "isTravelRegion",
                accessor: original => (original.isTravelRegion ? "YES" : "NO"),
                Cell: ({ original }) => (original.isTravelRegion ? "YES" : "NO"),
                className: classNameFlexCenter,
                Filter: ({ filter, onChange }) => (
                    <ReactTableFilterSelect
                        currentValue={filter ? filter.value : ""}
                        onChange={value => onChange(value)}
                        style={{ width: "100%", height: "100%" }}
                        optionsObject={{
                            "": "Show All",
                            YES: "YES",
                            NO: "NO"
                        }}
                    />
                )
            },
            {
                Header: "Active?",
                id: "inactive",
                accessor: original => (original.inactive ? "NO" : "YES"),
                Cell: ({ original }) => (original.inactive ? "NO" : "YES"),
                className: classNameFlexCenter,
                Filter: ({ filter, onChange }) => (
                    <ReactTableFilterSelect
                        currentValue={filter ? filter.value : ""}
                        onChange={value => onChange(value)}
                        style={{ width: "100%", height: "100%" }}
                        optionsObject={{
                            "": "Show All",
                            YES: "Active",
                            NO: "Inactive"
                        }}
                    />
                )
            },
            {
                Header: "Actions",
                id: "actions",
                className: classNameFlexCenter,
                Cell: ({ original }) => (
                    <ButtonGroup>
                        <Button size="sm" onClick={() => this.cityModalOpen(original.id)}>
                            <FontAwesomeIcon icon="pen" title="Update" />
                        </Button>
                        <Popconfirm
                            title={`Delete "${original.name}"?`}
                            onConfirm={() => this.delete(original.id, original.name)}
                            placement="bottomRight"
                            okText="Yes"
                            cancelText="Cancel"
                        >
                            <Button variant="danger" size="sm">
                                <FontAwesomeIcon icon="times" />
                            </Button>
                        </Popconfirm>
                    </ButtonGroup>
                ),
                filterable: false,
                width: 100
            }
        ];

        return (
            <div className="dashboard">
                <h3 className="mb-4">Cities {this.getProvinceName()}({cities.length})</h3>

                <ReactTable
                    data={cities}
                    headerClassName="table-header"
                    columns={columns}
                    defaultPageSize={20}
                    pageSizeOptions={[10, 20, 50, 100]}
                    resizable
                    className="-striped -highlight"
                    loading={loading}
                    filterable
                    defaultFilterMethod={filterCaseInsensitive}
                    defaultSorted={[
                        {
                            id: "name",
                            desc: false
                        }
                    ]}
                    defaultFiltered={[
                        {
                            id: "inactive",
                            value: "YES"
                        }
                    ]}
                    getNoDataProps = {() => ({
                        style: {
                            zIndex: 0
                        }
                    })}
                    style={{
                        height: "calc(100vh - 200px)",
                    }}
                />

                <div className="mt-4 mb-4 text-right">
                    <Button className="ml-2" variant="primary" onClick={() => this.cityModalOpen()}>
                        Add City
                    </Button>
                </div>
            </div>
        );
    }
}

CitiesList.propTypes = {
    fetchProvinceById: PropTypes.func.isRequired,
    fetchCities: PropTypes.func.isRequired,
    clearCities: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    currentProvince: state.locations.currentProvince,
    cities: state.locations.cities,
    loading: state.locations.loading
});

const mapStateToDispatch = dispatch => ({
    fetchProvinceById: bindActionCreators(fetchProvinceById, dispatch),
    fetchCities: bindActionCreators(fetchCities, dispatch),
    clearCities: bindActionCreators(clearCities, dispatch),
    deleteCity: bindActionCreators(deleteCity, dispatch),

    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(CitiesList);



// WEBPACK FOOTER //
// ./src/views/pages/locations/cities-list.js